import React from "react";

const Button = ({
    as: Component = "button",
    variant = "primary",
    size = "md",
    leadingIcon,
    trailingIcon,
    className = "",
    children,
    ...props
}) => {
    const classes = [
        "ui-btn",
        `ui-btn--${variant}`,
        size !== "md" ? `ui-btn--${size}` : "",
        !children && (leadingIcon || trailingIcon) ? "ui-btn--icon-only" : "",
        className,
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <Component className={classes} {...props}>
            {leadingIcon && <span className="ui-btn__icon">{leadingIcon}</span>}
            {children && <span className="ui-btn__label">{children}</span>}
            {trailingIcon && (
                <span className="ui-btn__icon ui-btn__icon--trailing">
                    {trailingIcon}
                </span>
            )}
        </Component>
    );
};

export default Button;

